import React from "react";
import logo from "../assets/agencybazaar-logo.png";

const MessageBubble = ({ sender, text }) => {
  return (
    <div
      style={{
        display: "flex",
        alignItems: "flex-start",
        gap: "8px",
        marginBottom: "12px",
        flexDirection: sender === "user" ? "row-reverse" : "row",
      }}
    >
      {/* AI Logo */}
      {sender === "ai" && (
        <img
          src={logo}
          alt="NISHI"
          style={{
            width: "32px",
            height: "32px",
            borderRadius: "50%",
            objectFit: "cover",
            flexShrink: 0,
          }}
        />
      )}

      <div
        className={`message-bubble ${sender === "user" ? "user-message" : "ai-message"}`}
      >
        {text}
      </div>
    </div>
  );
};

export default MessageBubble;
